<template>
	<div class="main-body">
		<div class="container">
			<!-- 筛选标签 -->
			<div class="filter-tabs">
				<div class="filter-tab" :class="pageTypeIndex==0?'filter-tab active':''" @click="switchAction(0)">全部
				</div>
				<!-- <view class="filter-tab" :class="pageTypeIndex==1?'filter-tab active':''" @click="switchAction(1)">最新
				</view> -->
				<div class="filter-tab" :class="pageTypeIndex==2?'filter-tab active':''" @click="switchAction(2)">星级
				</div>
				<div class="filter-tab" :class="pageTypeIndex==3?'filter-tab active':''" @click="switchAction(3)">项目
				</div>
			</div>
			<!-- 评价列表 -->
			<div class="evaluation-list-content">
				<!-- 列表 -->
				<div class="evaluation-list" v-if="isAddGoodsEvaluate=='query'">
					<div v-for="(item,index) in evaluationData" class="" :key="index">
						<div class="evaluation-item">
							<div class="evaluation-header">
								<div class="evaluation-date">{{item.Creation}}</div>
								<div class="evaluation-star">
									<div class="" v-for="(url,j) in item.star" :key="j">
										<img class="star-image"   :src="url" />
									</div>
								</div>
							</div>
							<div class="evaluation-project">{{item.ProductName==null?"":item.ProductName}}</div>
							<div class="evaluation-content">{{item.Content}}</div>
							<div class="evaluation-images" v-if="item.imagesList.length>0">
								<div class="" v-for="(url,k) in item.imagesList" :key="k">
									<img class="evaluation-image" :src="url" @click="showBigImage(url)" />
								</div>
							</div>

							<div class="CommentBacks"  v-if="item.CommentBacks&&item.CommentBacks.length>0">
								<div v-for="(mode,kk)  in item.CommentBacks" :key="kk">
									<div class="evaluation-content">商家回复:{{mode.Content}}</div>
									<div class="evaluation-images" v-if="mode.imagesList.length>0">
										<div class="" v-for="(url,kkk) in mode.imagesList" :key="kkk">
											<img class="evaluation-image" :src="url" @click="showBigImage(url)" />
										</div>
									</div>
								</div>
							</div>

						</div>

					</div>

					<div class="loading" v-if="loading">
						加载中...
					</div>

					<div class="no-more" v-if="noMore">
						没有更多评价了
					</div>
				</div>
				<!-- 新增评价 -->
				<div class="add-new-evaluation-content" v-else-if="isAddGoodsEvaluate=='add'">

					<div class="add-evaluation-item" @click="switchAction(999)">
						<div class="add-evaluation-item-title" style="text-align: left;">项目</div>
						<div style="flex:2;" />
						<div class="add-evaluation-item-right" style="text-align: right;">{{mParam.ProductName}}</div>
						<img src="/static/images/icon_on_the_right.png" class="add-evaluation-item-image">
					</div>
					<div class="add-evaluation-item">
						<div class="add-evaluation-item-title">评价</div>
						<div class="add-evaluation-item-right" style="flex: 1;">
							<div style="flex: 1;" />
							<div class="" v-for="(item,j) in defaultImage" @click="updateScor(item,j)" :key="j">
								<img v-if="item.Seleted" class="star-image" :src="item.check" />
								<img v-else class="star-image" :src="item.nomal" />
							</div>
						</div>
					</div>
					<div class="add-evaluation-item">
						<div class="add-evaluation-item-title">内容</div>
						<textarea class="add-evaluation-item-right-textarea" v-model="mParam.Content"
							placeholder="请填写内容" />
					</div>
					<div class="add-evaluation-item">
						<div class="add-evaluation-item-title">图片</div>
						<div class="add-evaluation-item-right" style="flex: 1;">
							<div style="flex: 1;" />
							<div class="add-evaluation-image" style="text-align: center;" @click="uploadImage">请点击添加图片
							</div>
						</div>
					</div>
					<div class="add-evaluation-item" style="height: 200rpx;">
						<div class="add-evaluation-item-right" style="padding-left: 20rpx;">
							<div class="" v-for="(url,j) in mParam.ImagesList" :key="j">
								<img class="star-image" style="height: 4.0rem;width: 4.0rem;margin-left: 0.5rem;"
									:src="url" @click="showBigImage(url)">
									<img  class="shanchu-image" src="/static/images/shanchu.png"
										@click="deletedImage(url)" />
								</img>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="add-evaluation-view">
			<div class="add-evaluation" @click="AddGoodsEvaluateAction()">{{btnvalue}}</div>
		</div>


		  <van-dialog
      :title="popviewTitle"
      v-model="showPopup"
      show-cancel-button
      cancelButtonText="关闭"
      :show-confirm-button="false"
      @close="hideModel"
    >
			<div class="card_bottom_con">
				<div class="popup-content">
					<div style="height: 100%;overflow-y: auto;">
						<div v-for="(item,index) in consumeGoodsList" class="" :key="index">
							<div class="popup-evaluation-item">
								<div v-if="item.Seleted" style="background-color:#C6A675;color: white;"
									class="popup-evaluation-project"
									@click="handleSureSubmit(item,index)">{{item.name}}</div>
								<div v-else style="background-color:white; color: black;"
									class="popup-evaluation-project"
									@click="handleSureSubmit(item,index)">{{item.name}}</div>
							</div>
						</div>
					</div>
				</div>
				<div style="height: 30rpx;width: 100%;background-color: #f5f5f5;" />
			
			</div>
		</van-dialog>

		<van-dialog 
		 title="大图"
      v-model="showBigPopup"
      show-cancel-button
      cancelButtonText="关闭"
      :show-confirm-button="false"
      @close="hideModel"
		>
			<div class="card_bottom_con" style="background-color: transparent;">
				<div class="bigPopup-content">
					<img style="height:400px;width: 100%;background-color: transparent;object-fit: contain;"
						:src="bigSrc" @click="closeBigPopup" />
				</div>
			</div>
		</van-dialog> 
	</div>

</template>
<script >
import {
  applyAddEvaluate,
  queryConsumeitems,
  queryEvaluate,
} from "../../api/goods";
import wxConfig from "@/utils/wxConfig.js";
import { chooseImage } from 'weixin-js-sdk';
export default {
  name: "goodsEvaluate",
  data() {
    return {
      mParam: {
        Content: "",
        Score: 5,
        Images: "",
        ProductName: "请选择项目",
        vpnId: "",
        ImagesList: [],
        lstImageBase64Text: [],
      },
      queryParam: {
        PageIndex: 0,
        Score: null,
        productName: "",
      },
      bigSrc: "",
      consumeGoodsList: [],
      mGoodsList: [],
      defaultImage: [
        {
          nomal:require("@/assets/images/xingxing.png"),
          check: require("@/assets/images/staron.png"),
          Seleted: true,
        },
        {
          nomal:require("@/assets/images/xingxing.png"),
          check: require("@/assets/images/staron.png"),
          Seleted: true,
        },
        {
          nomal: require("@/assets/images/xingxing.png"),
          check: require("@/assets/images/staron.png"),
          Seleted: true,
        },
        {
          nomal:require("@/assets/images/xingxing.png"),
          check: require("@/assets/images/staron.png"),
          Seleted: true,
        },
        {
          nomal: require("@/assets/images/xingxing.png"),
          check: require("@/assets/images/staron.png"),
          Seleted: true,
        },
      ],
      mTotalPage: 0,
      pageTypeIndex: 0,
      remark: "",
      popviewTitle: "星级筛选",
      isAddGoodsEvaluate: "query",
      btnvalue: "新增评价",
      evaluationData: [],
      loading: false,
      noMore: false,
      showPopup: false,
      showBigPopup: false,
    };
  },

  mounted() {
    window.addEventListener("scroll", this.handleLoadMore);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleLoadMore);
  },
  onLoad() {},
  created() {
    this.vpnId = this.$store.state.vpnId;
    this.mParam.vpnId = this.$store.state.vpnId;
    this.queryEvaluateList();
    this.queryGoods();
    wxConfig.getWxParameter(this);
  },

  onReachBottom() {
    this.handleLoadMore();
  },
  methods: {
    hideModel() {
      this.showPopup = false;
      this.showBigPopup = false;
    },
    deletedImage(url) {
      this.mParam.ImagesList = this.mParam.ImagesList.filter(
        (mode) => mode != url
      );
    },
    handleLoadMore() {
      if (this.loading || this.noMore) return;
      this.loading = true;
      this.queryParam.PageIndex = this.queryParam.PageIndex + 1;
      this.queryEvaluateList();
    },
    closeBigPopup() {
      this.showBigPopup = false;
    },
    showBigImage(url) {
      this.bigSrc = url;
      this.showBigPopup = true;
    },

    AddGoodsEvaluateAction() {
      if (this.isAddGoodsEvaluate === "add") {
        this.ApplyEvaluate();
      } else {
        this.btnvalue = "提交评价";
        this.isAddGoodsEvaluate = "add";
      }
    },
    /**新增*/
    ApplyEvaluate() {
      this.mParam.lstImageBase64Text = [];
      this.mParam.vpnId = this.vpnId;
      if (this.mParam.Content.length == 0) {
          this.$toast( "请填写评价内容")
        return;
      }
      if (this.mParam.ProductName === "请选择项目") {
        this.mParam.ProductName = "";
      }
      if (this.mParam.ProductName === "全部") {
        this.mParam.ProductName = "";
      }
      if (this.mParam.ImagesList.length > 4) {
          this.$toast( "最多上传4张照片")
        return;
      }
      
      this.mParam.ImagesList.forEach((mode) => {
        if(mode.includes('data:image/jpeg;base64,')){
           mode = (mode+"").replace('data:image/jpeg;base64,','') 
        }else  if(mode.includes('data:image/png;base64,')){
           mode = (mode+"").replace('data:image/png;base64,','') 
        }else  if(mode.includes('data:image/jpg;base64,')){
           mode = (mode+"").replace('data:image/jpg;base64,','') 
        }
        this.mParam.lstImageBase64Text.push(mode);
      });
      this.mParam.Score = this.defaultImage.filter(
        (mode) => mode.Seleted == true
      ).length;
      applyAddEvaluate(this.mParam)
        .then((res) => {
          this.mParam = {
            Content: "",
            Score: 5,
            Images: "",
            ProductName: "请选择项目",
            vpnId: this.vpnId,
            ImagesList: [],
            lstImageBase64Text: [],
          };
          this.defaultImage.forEach((mode, index) => {
            mode.Seleted = true;
            this.defaultImage[index] = mode;
          });
          this.btnvalue = "新增评价";
          this.isAddGoodsEvaluate = "query";
          this.queryParam.PageIndex = 0;
          this.evaluationData = [];
          this.loading = false;
          this.noMore = false;
          this.queryEvaluateList();
        })
        .catch((error) => {
          uni.showToast({
            title: JSON.stringify(error),
            icon: "error",
          });
        });
    },
    /**查询*/
    queryEvaluateList() {
      var mParam = {
        "query.VpnId": this.vpnId,
        "query.productName": this.queryParam.productName,
        "pager.PageIndex": this.queryParam.PageIndex,
        "pager.pagesize": 20,
      };
      if (this.queryParam.Score != null) {
        mParam = {
          "query.Score": this.queryParam.Score,
          ...mParam,
        };
      }
      queryEvaluate(mParam)
        .then((res) => {
          this.mTotalPage = res.Pager.TotalPage;
          if (res.Items instanceof Array) {
            res.Items.forEach((mode, index) => {
              mode.star = [];
              mode.imagesList = [];
              const imageList = (mode.Images + "").split(",");
              mode.imagesList = imageList.filter((img) => img.length > 3);
              if (mode.Score == 5) {
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/staron.png"));
              } else if (mode.Score == 4) {
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
              } else if (mode.Score == 3) {
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
              } else if (mode.Score == 2) {
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
              } else if (mode.Score == 1) {
                mode.star.push(require("@/assets/images/staron.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
              } else {
                mode.star.push(require("@/assets/images/xingxing.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
                mode.star.push(require("@/assets/images/xingxing.png"));
              }

              if (
                mode.CommentBacks instanceof Array &&
                mode.CommentBacks.length > 0
              ) {
                mode.CommentBacks[0].imagesList = [];
                const imageList = (mode.CommentBacks[0].Images + "").split(",");
                mode.CommentBacks[0].imagesList = imageList.filter(
                  (img) => img.length > 3
                );
              }
              res.Items[index] = mode;
            });
          }
          this.evaluationData.push(...res.Items);
          this.loading = false;
          if (res.Items.length === 0) {
            this.noMore = true;
          }
        })
        .catch((error) => {
          this.loading = false;
        });
    },
    /**打分*/
    updateScor(item, index) {
      item.Seleted = !item.Seleted;
      this.defaultImage[index] = item;
    },


    /*上传图片*/
    uploadImage() {
      if (this.mParam.ImagesList.length >= 4) {
          this.$toast( "最多上传4张照片")
        return;
      } 
      wxConfig.chooseImage(this,(res)=>{

         this.$toast( res)
         if (res.length > 0) {
            this.mParam.ImagesList.push(...res);
          }
          if (this.mParam.ImagesList.length > 4) {
            this.mParam.ImagesList = this.mParam.ImagesList.slice(0, 4);
              this.$toast( "最多上传4张照片")
          }
      })
    },
    handleSureCancel() {
      this.showPopup = false;
    },
    handleSureSubmit(item, index) {
      if (this.popviewTitle === "星级筛选") {
        this.showPopup = false;
        this.consumeGoodsList.forEach((mode, j) => {
          mode.Seleted = item.Score === mode.Score;
          this.consumeGoodsList[j] = mode;
        });
        this.queryParam.Score = item.Score;
        this.evaluationData = [];
        this.queryEvaluateList();
      } else if (this.popviewTitle === "项目筛选") {
         this.showPopup = false;
        this.consumeGoodsList.forEach((mode, j) => {
          mode.Seleted = item.Score === mode.Score;
          this.consumeGoodsList[j] = mode;
        });
        this.queryParam.productName = item.Score;
        this.evaluationData = [];
        this.queryEvaluateList();
      } else if (this.popviewTitle === "选择项目") {
        this.consumeGoodsList.forEach((mode, j) => {
          mode.Seleted = item.Score === mode.Score;
          this.consumeGoodsList[j] = mode;
        });
        this.mParam.ProductName = item.name;
      }
    },
    switchAction(type) {
      this.queryParam.PageIndex = 0;
      this.loading = false;
      this.noMore = false;
      if (type != 999) {
        this.btnvalue = "新增评价";
        this.isAddGoodsEvaluate = "query";
        this.pageTypeIndex = type;
        if (type == 0) {
          (this.queryParam.PageIndex = 0), (this.evaluationData = []);
          this.queryEvaluateList();
        } else if (type == 2) {
          this.queryDefaultStar();
          this.popviewTitle = "星级筛选";
          this.showPopup = true;
        } else if (type == 3) {
          this.consumeGoodsList = [];
          this.consumeGoodsList.push(...this.mGoodsList);
          const item = this.consumeGoodsList.find(
            (mode) => mode.name === this.queryParam.name
          );
          if (item != undefined) {
            this.consumeGoodsList.forEach((mode, j) => {
              mode.Seleted = item.name === mode.name;
              this.consumeGoodsList[j] = mode;
            });
          }
          this.popviewTitle = "项目筛选";
          this.showPopup = true;
        }
      } else {
        this.consumeGoodsList = [];
        this.consumeGoodsList.push(...this.mGoodsList);
        const item = this.consumeGoodsList.find(
          (mode) => mode.name === this.mParam.ProductName
        );
        if (item != undefined) {
          this.consumeGoodsList.forEach((mode, j) => {
            mode.Seleted = item.name === mode.name;
            this.consumeGoodsList[j] = mode;
          });
        }
        this.popviewTitle = "选择项目";
        this.showPopup = true;
      }
    },
    /**获取评价项目**/
    queryGoods() {
      queryConsumeitems(this.vpnId)
        .then((res) => {
          this.mGoodsList = [];
          this.mGoodsList.push({
            name: "全部",
            Score: "",
            Seleted: true,
          });
          res.forEach((mode, index) => {
            this.mGoodsList.push({
              name: mode,
              Score: mode,
              Seleted: false,
            });
          });
        })
        .catch((error) => {});
    },
    queryDefaultStar() {
      this.consumeGoodsList = [];
      this.consumeGoodsList.push({
        name: "全部",
        Score: null,
        Seleted: true,
      });
      this.consumeGoodsList.push({
        name: "五星",
        Score: "5",
        Seleted: false,
      });
      this.consumeGoodsList.push({
        name: "四星",
        Score: "4",
        Seleted: false,
      });
      this.consumeGoodsList.push({
        name: "三星",
        Score: "3",
        Seleted: false,
      });
      this.consumeGoodsList.push({
        name: "二星",
        Score: "2",
        Seleted: false,
      });
      this.consumeGoodsList.push({
        name: "一星",
        Score: "1",
        Seleted: false,
      });

      const item = this.consumeGoodsList.find(
        (mode) => mode.Score === this.queryParam.Score
      );
      if (item != undefined) {
        this.consumeGoodsList.forEach((mode, j) => {
          mode.Seleted = item.Score === mode.Score;
          this.consumeGoodsList[j] = mode;
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-body {
  height: 100%;
  width: 100%;
  background-color: #f5f5f5;
  color: #333;
  padding: 0;
  margin: 0;
}

.container {
  background-color: #f5f5f5;
  width: 100%;
  height: 100%;
}

/* 筛选标签 */
.filter-tabs {
  position: fixed;
  display: flex;
  background-color: #fff;
  border-bottom: 1px solid #c6a675;
  position: sticky;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 10;
}

.filter-tab {
  flex: 1;
  text-align: center;
  padding: 12px 0;
  height: 80px;
  line-height: 80px;
  font-size: 15px;
  font-size: 0.8rem;
  color: #666;
  position: relative;
}

.filter-tab.active {
  color: #c6a675;
  font-weight: 500;
}

.filter-tab.active::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  height: 2px;
  background-color: #c6a675;
}

.evaluation-list-content {
  width: 100%;
  height: 100%;
}

/* 评价列表 */
.evaluation-list {
  padding: 0 10px;
  margin-left: 10px;
  // width: 98%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 200px;

  // 	height: calc(100vh - 100rpx - env(safe-area-inset-bottom));
}

.evaluation-item {
  display: grid;
  padding: 15px 0;
  height: auto;
  background: #ffffff;
  border-radius: 8px;
  border: 1px solid #e5e5e5;
  margin-bottom: 10px;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
    0px 4px 6px 0px rgba(0, 0, 0, 0.04);
}

.evaluation-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
}

.evaluation-date {
  padding-left: 20px;
  font-size: 13px;
  color: #999;
}

.evaluation-star {
  display: flex;
  width: auto;
  padding-right: 20px;
}

.star-image {
  height: 30px;
  width: 30px;
}

.evaluation-project {
  padding-left: 20px;
  padding-right: 20px;
  font-size: 0.8rem;
  color: #c6a675;
  font-weight: 500;
  color: #333;
}

.evaluation-content {
  font-size: 0.7rem;
  color: #333;
  padding-left: 20px;
  padding-right: 20px;
  line-height: 1.5;
  margin-bottom: 10px;
  word-break: break-word;
}

.evaluation-images {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding-left: 20px;
  margin-top: 10px;
}

.evaluation-image {
  width: 5rem;
  height: 5rem;
  border-radius: 4px;
  object-fit: cover;
  background-color: #f5f5f5;
}

.add-evaluation-view {
  @include fixed-bottom-box-con;
  justify-content: space-between;
  width: 100%;
  height: 130px;
  background-color: white;

  .add-evaluation {
    position: fixed;
    bottom: 30px;
    right: 50px;
    left: 50px;
    height: 80px;
    background-color: #c6a675;
    border-radius: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 32px;
    // box-shadow: 0 2px 10px rgba(7, 193, 96, 0.3);
  }
}

.add-new-evaluation-content {
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04),
    0px 4px 6px 0px rgba(0, 0, 0, 0.04);
  border-radius: 8px;
  border: 1rpx solid #e5e5e5;

  .add-evaluation-item {
    height: 122px;
    width: 100%;
    text-align: center;
    display: flex;
    border-bottom: 1px solid #f6f6fe;

    .add-evaluation-item-title {
      line-height: 122px;
      width: auto;
      height: 122px;
      font-weight: 500;
      padding-left: 20px;
    }

    .add-evaluation-item-right {
      text-align: right;
      display: flex;
      height: 122px;
      line-height: 122px;
      padding-right: 20px;
      background-color: white;
    }

    .add-evaluation-item-image {
      height: 22px;
      width: 22px;
      padding-right: 20px;
      margin-top: 50px;
    }

    .add-evaluation-image {
      color: #e8ba62;
      font-size: 18.4px;
      width: 192px;
      height: 108px;
      background: rgba(232, 186, 98, 0.2);
      box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
      border-radius: 7px;
      border: 1rpx solid #e8ba62;
    }
    .add-evaluation-item-right-textarea {
      flex: 1;
      text-align: right;
      display: flex;
      height: 80px;
      resize: none;
      padding-top: 20px;
      padding-right: 20px;
      background-color: white;
      line-height: 1;
      border: 1px solid lightgray;
      border-radius: 4px;
      margin-left: 10px;
      margin-right: 10px;
    }
  }
}

.CommentBacks {
  background-color: aliceblue;
  margin: 20rpx;
  padding: 6px;
  font-size: 0.6rem;
  border-radius: 10px;
}

.card_bottom_con {
  background: #fff;
  margin: 10px;
  padding-bottom: 1rem;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

.popup-title {
  text-align: center;
  height: 100px;
  padding-top: 30px;
  width: 100%;
  color: black;
  font-size: 36px;
  font-weight: 500;
  border-bottom: 1px solid #f3f3f3;
}

.popup-content {
  height: 25rem;
  width: 100%;
  color: black;
  font-size: 20px;
}

.bigPopup-content {
  height: 100%;
  width: 100%;
  background-color: transparent;
}

.popup-evaluation-item {
  text-align: center;
  display: grid;
  height: 100px;
  line-height: 100px;
  font-weight: 300;
  background: #ffffff;
  border: 1px solid #e5e5e5;
}

.popup-evaluation-project {
  font-size: 30px;
  text-align: center;
  color: #333;
}

.loading {
  text-align: center;
  padding: 15px;
  color: #999;
  font-size: 14px;
}

.no-more {
  text-align: center;
  padding: 15px;
  color: #999;
  font-size: 14px;
}

.shanchu-image {
  width: 20px;
  height: 20px;
  margin-bottom: 3.8rem;
  margin-left: -0.5rem;
}
</style>